import Blue from "~/core";

new Blue({
	name: 'Modal',
	selector: ".modal__trigger[data-modal-trigger]",
	setup(trigger) {
		const id = trigger.dataset.modalTrigger;
    const modal = document.querySelector(`.modal[data-modal=${id}]`);
    const swiper = modal.closest('.swiper');

    const close = modal.querySelector('.modal__close');
    const contentWrapper = modal.querySelector('.modal__content-wrapper');
    const videoWrapper = modal.querySelector('.modal__media-wrapper');
    const video = modal.querySelector('video');
    const iframe = modal.querySelector('iframe');
		
    const stopVideo = () => {
			videoWrapper.classList.remove('is-playing');
      if (video) {
				video.pause();
      }
      else if(iframe) {
				let iframeSrc = iframe.getAttribute('src');
				iframe.removeAttribute('src')
				iframe.setAttribute('src', iframeSrc)
      }
    }

    const openModal = () => {
      modal.classList.add('is-open');
      if (swiper) {
        swiper.classList.add('is-modal-open');
        swiper.swiper && swiper.swiper.autoplay.running ? swiper.swiper.autoplay.stop() : null;
      }
			this.$scrollLock.lock(modal);
    }

    const closeModal = () => {
      modal.classList.remove('is-open');
      if (swiper) swiper.classList.remove("is-modal-open");
      this.$scrollLock.unlock(modal);
      stopVideo();
    }


    if(this.$browser.name === 'chrome' && this.$browser.os.toLowerCase() === 'android os') {
    	videoWrapper.classList.add('is-android');
    }
    this.$addEvents(contentWrapper, "click.stop.prevent", () => {});
    this.$addEvents(close, "click.stop.prevent", closeModal);
    this.$addEvents(modal, "click.stop.prevent", closeModal);
    this.$addEvents(trigger, "click.stop.prevent", openModal);
		if (video) {
			this.$addEvents(video, "ended", stopVideo);
		}
	}
});